var loadCompany;


$(function () {
    loadCompany = {

        page: 1,
        state: initState,
        loading: false,
        finished: false,
        textSearch: textSearch,

        loadNext: function () {
            loadCompany.page = loadCompany.page + 1;
            loadCompany.load();
        },

        fnFormataUrl: function(site, linkedin){
          var url = "#";
          if (linkedin != "") url = "/redirect/linkedin/?url="+linkedin;
          if (site != "") url = "/redirect/website/?url="+site;
          return url;
        },

        analytics: function(){
          let loadingElements = document.getElementsByClassName('loading');
          if (typeof gtag === "function" && loadingElements.length > 0) {
              gtag('event', 'page_view', {
                  'event_category': 'company',
                  'event_label': 'Page ' + loadCompany.page,
                  'value': 1
              });
          }
        },

        load: function () {
            if (loadCompany.finished) return;
            $(".loading").fadeIn();
            loadCompany.loading = true;
            $.ajax({
                dataType: "json",
                url: loadCompany.textSearch == "" ? `/api/v1/companies/${loadCompany.page}/${loadCompany.state}` : `/api/v1/companies/${loadCompany.page}/${loadCompany.state}/${loadCompany.textSearch}`,
                success: function (req) {

                    if (req[1].companies.length == 0) {
                      loadCompany.finished = true;
                    } else {
                      //Advertising
                      if (loadCompany.page > 1){
                        let ad = req[0].advertising[0];
                        let ad_template = `<div class="cell large-12 ultra-banner">
                                        <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                                        <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                                        </div>`;
                        $(".empresas-lista").append(ad_template);
                        $.get(`/api/advertising-views/${ad.id}/`)
                      }
                      //Companies
                        $(req[1].companies).each(function (ix, x) {
                            let template = `
                              <div class="empresa destaque-${x.destaque}">
                                ${(x.destaque==1) ? `<div class="recomendamos-label"><img src="/static/img/recomendamos-top.png" /></div>` : ``}
                                <div class="nome-da-empresa"><a href="${loadCompany.fnFormataUrl(x.site, x.linkedin)}" target="_blank">${x.nome_da_empresa}</a></div>
                                <div class="grid-x grid-padding-x">
                                ${(x.tem_imagem==1) ? `
                                  <div class="cell large-3 medium-3 small-5">
                                    <div class="imagem"><img src="/api/v1/diminuator?file=img/companies/${x.imagem_local}&w=100&h=100" /></div>
                                  </div>
                                  ` : ``}
                                  <div class="cell ${(x.tem_imagem==1) ? `large-9 medium-9 small-7` : `large-12 medium-12 small-12`}">
                                    ${(x.site) ? `<div class="site"><strong>Site:</strong> <a href="/redirect/website/?url=${x.site}" rel="nofollow" target="_blank">${x.site}</a></div>` : ``}
                                    ${(x.telefone) ? `<div class="telefone"><strong>Telefone:</strong> ${x.telefone}</div>` : ``}
                                    ${(x.endereco) ? `<div class="endereco"><strong>Endereço:</strong> ${x.endereco}</div>` : ``}
                                    ${(x.cidade || x.estado) ? `
                                      <div class="spacer-10"></div>
                                      <div class="estado">
                                        <strong>Local: </strong>
                                          ${x.cidade ? x.cidade:''}
                                          ${(x.cidade && x.estado)?' / ':''}
                                          ${x.estado ? x.estado:''}
                                      </div>` :
                                    ``}
                                  </div>
                                </div>
                                <div class="redes-sociais">
                                ${(x.site) ? `<span><a href="/redirect/website/?url=${x.site}" rel="nofollow" target="_blank" class="icon"><img src="/static/img/icon-website.png" /></a></span>` : ``}
                                ${(x.instagram) ? `<span><a href="/redirect/instagram/?url=${x.instagram}" rel="nofollow" target="_blank" class="icon"><img src="/static/img/icon-instagram.png" /></a></span>` : ``}
                                ${(x.linkedin) ? `<a href="/redirect/linkedin/?url=${x.linkedin}" rel="nofollow" target="_blank" class="icon"><img src="/static/img/icon-linkedin.png" /></a>` : ``}
                                </div>
                              </div>
                        `
                            $(".empresas-lista").append(template);
                        })
                    }
                    $(".loading").fadeOut();
                    loadCompany.analytics();
                    loadCompany.loading = false;
                }
            });
        },

        search: function(div){
          var search = $(`.search-form.${div} #searchText`).val().toString();
          if(!search){
              document.location.href = `/oficinas/`;
          } else if(search && loadCompany.state && loadCompany.state != "all") {
              document.location.href = `/oficinas/${loadCompany.state}/${search}/`;
          } else {
            document.location.href = `/oficinas/${search}/`;
          }
        }
    }

    $(".search-form.desktop .icon").click(function(){
      $(".search-form .form").animate({width:'toggle'},350);
      $("#searchText").focus();
    });

    $(".search-form.desktop #btnOk").click(function(){ loadCompany.search('desktop'); });
    $(".search-form.mobile #btnOk").click(function(){ loadCompany.search('mobile'); });

    $(".search-form.desktop #searchText").on('keypress',function(e) {
      if(e.which == 13) $(".search-form.desktop #btnOk").click()
    });

    if(textSearch){
      $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
      $(".search-form").addClass("search")
    }

    window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadCompany.loading === false) {
        loadCompany.loadNext();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };
})

$("#back-to-top").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow", function() {
      $('#back-to-top').removeClass('visible');
    });
  });
